var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"http-404"},[_c('img',{attrs:{"src":"/img/404.gif","alt":"Funny 404 GIF"}}),_c('p',[_vm._v("Nothing to see here")])])}]

export { render, staticRenderFns }